import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Categoria, CategoriaJSON } from './Categoria';
export class CategoriaSystem {
  private readonly base = '/categorias';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getCategoriaIdentifiedBy(id: string): Promise<Categoria> {
    const data = await this.requestHandler.get<CategoriaJSON>(`${this.base}/${id}`);
    return Categoria.fromJSON(data);
  }

  async getList(): Promise<Categoria[]> {
    const data = await this.requestHandler.get<CategoriaJSON[]>(`${this.base}`);
    return data.map((entity) => Categoria.fromJSON(entity));
  }

  async getListForDropdown(params: string = ''): Promise<Categoria[]> {
    const data = await this.requestHandler.get<CategoriaJSON[]>(`${this.base}/for-dropdown${params}`);
    return data.map((entity) => Categoria.fromJSON(entity));
  }

  async getListForDropdownForTorneo(temId: string = ''): Promise<Categoria[]> {
    const params = temId ? `?tem_id=${temId}` : '';
    return this.getListForDropdown(params);
  }

  async save(entity: Categoria) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<CategoriaJSON, CategoriaJSON>(this.base, data);
    return Categoria.fromJSON(savedEntity);
  }

  async saveNew(entity: Categoria) {
    const data = entity.toJSONnew();
    const savedEntity = await this.requestHandler.post<CategoriaJSON, CategoriaJSON>(this.base, data);
    return Categoria.fromJSON(savedEntity);
  }

  async delete(id: string) {
    return await this.requestHandler.put<null, any>(`${this.base}/delete/${id}`, {});
  }

  async getCategoria(year: string): Promise<CategoriaJSON> {
    if (!year) year = '2023';
    const data = await this.requestHandler.get<CategoriaJSON>(`${this.base}/by-year/${year}`);

    return data;
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
